import type { DataDispatch } from "../data-context/DataContextProvider";
import { BASE_URL, parseApiError } from "../utils/apiCallsUtils";

export async function getPlanData(params: {
  days: string[];
  buType: string;
  buCode: string;
  callBack: DataDispatch;
}): Promise<void> {
  //console.log("Fetching plan data with params:", params);
  const url = `${BASE_URL}/planning/day-plans/${params.buCode}/${params.buType}`;
  try {
    const response = await fetch(url, {
      method: "POST",
      mode: "cors",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params.days),
    });

    if (!response.ok) {
      const apiError = await parseApiError(response);
      console.error("Error fetching plan data:", apiError);
      params.callBack({ type: "SET_API_ERROR", payload: apiError });
      return;
    }

    const data = await response.json();
    //console.log("Fetched plan data:", data);
    params.callBack({
      payload: data,
      type: "SET_PLAN_DATA",
    });
  } catch (error) {
    console.error("Error fetching plan data:", error);
  }
}

export async function updatePlanData(params: {
  itemCode: string;
  /** First hour the card covers, YYYYMMDDHH. */
  fromHour: string;
  /** Last hour the card covers. Keys the daily task and is the itemSalesPlan row the server writes to. */
  toHour: string;
  buCode: string;
  buType: string;
  statusCode: string;
  producedVol: number;
  availableVol: number;
  comment: string;
  callBack: DataDispatch;
}): Promise<boolean> {
  const url = `${BASE_URL}/planning/daily-tasks`;

  try {
    const response = await fetch(url, {
      method: "POST",
      mode: "cors",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: {
          businessUnit: {
            buCode: params.buCode,
            buType: params.buType,
          },
          itemCode: params.itemCode,
          toHour: params.toHour,
          registerGroupId: "999", // Update when the actual register group ID is available
        },
        fromHour: params.fromHour,
        statusCode: params.statusCode,
        producedVol: params.producedVol,
        availableVol: params.availableVol,
        comment: params.comment,
        taskFoodBatchies: [],
      }),
    });

    if (!response.ok) {
      const apiError = await parseApiError(response);
      console.error("Error updating plan data:", apiError);
      params.callBack({ type: "SET_API_ERROR", payload: apiError });
      return false;
    }
    params.callBack({
      type: "UPDATE_PLAN_ITEM",
      payload: {
        plannedDayHour: params.toHour,
        itemCode: params.itemCode,
        producedVol: params.producedVol,
        availableVol: params.availableVol,
        statusCode: params.statusCode,
      },
    });

    return true;
  } catch (error) {
    console.error("Error updating plan data:", error);
    return false;
  }
}
